import { resolveApiBaseUrl } from "./config";

type JsonObject = Record<string, unknown>;

function buildApiUrl(endpoint: string): string {
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  return `${resolveApiBaseUrl()}/api/v1${cleanEndpoint}`;
}

async function request(method: "GET" | "POST", endpoint: string, body?: unknown): Promise<unknown> {
  const url = buildApiUrl(endpoint);
  const response = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`HTTP ${response.status} for ${url}: ${text.slice(0, 300)}`);
  }
  if (response.status === 204) {
    return {};
  }
  return (await response.json()) as JsonObject;
}

export const apiClient = {
  get(endpoint: string): Promise<unknown> {
    return request("GET", endpoint);
  },
  post(endpoint: string, body: unknown): Promise<unknown> {
    return request("POST", endpoint, body);
  },
};
